import React from 'react';
const bonuses = [{
  num: 1,
  title: 'Identificá tus heridas emocionales',
  desc: 'Descubrí el origen de tus reacciones actuales',
  price: '$8.000 ARS'
}, {
  num: 2,
  title: 'Soltar culpa y resentimiento',
  desc: 'Herramientas para liberar el peso del pasado',
  price: '$7.000 ARS'
}, {
  num: 3,
  title: 'Qué hacer si no querés hablar',
  desc: 'Sanación interna sin necesidad de contacto',
  price: '$6.000 ARS'
}, {
  num: 4,
  title: 'Cómo cerrar etapas sin conversación',
  desc: 'Rituales y técnicas de cierre personal',
  price: '$5.000 ARS'
}, {
  num: 5,
  title: 'Poner límites sin recaer',
  desc: 'Mantené tu postura con firmeza y amor propio',
  price: '$7.000 ARS'
}, {
  num: 6,
  title: 'Plan de acción en 7 días',
  desc: 'Pasos claros para ver cambios inmediatos',
  price: '$6.000 ARS'
}];
export function BonusSection() {
  return <section className="text-white py-5 px-5 bg-[#000000]" data-id="element-40">
      <div className="max-w-xl mx-auto" data-id="element-41">
        <div className="text-center mb-8" data-id="element-42">
          <h2 className="text-2xl md:text-3xl font-extrabold mb-2" data-id="element-43">
            🎁 PERO ESO NO ES TODO... RECIBÍ TAMBIÉN LOS 6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-sm text-gray-400 font-medium" data-id="element-44">
            Incluidos en todas las ofertas
          </p>
        </div>

        <div className="space-y-3 mb-8" data-id="element-45">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-slate-900 border-2 border-brand-yellow rounded-xl p-5 relative overflow-hidden" data-id="element-46">
              {/* GRATIS badge */}
              <div className="absolute top-3 right-3 bg-red-600 text-white text-[10px] font-black px-2.5 py-1 rounded-md flex items-center gap-1" data-id="element-47">
                🎁 GRATIS
              </div>

              {/* Bono label */}
              <div className="flex items-center gap-3 mb-2" data-id="element-48">
                <div className="bg-brand-yellow/10 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-49">
                  <span className="text-lg" data-id="element-50">🎁</span>
                </div>
                <span className="text-[11px] text-slate-500 font-bold uppercase tracking-wider" data-id="element-51">
                  BONO {bonus.num}
                </span>
              </div>

              {/* Title */}
              <h3 className="text-base font-black text-white mb-1 pr-16" data-id="element-52">
                {bonus.title}
              </h3>

              {/* Description */}
              <p className="text-xs text-slate-500 mb-3 leading-relaxed" data-id="element-53">
                {bonus.desc}
              </p>

              {/* Price */}
              <div className="flex items-center gap-2" data-id="element-54">
                <span className="text-sm text-slate-600 line-through" data-id="element-55">
                  {bonus.price}
                </span>
                <span className="text-sm font-black text-green-500" data-id="element-56">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-slate-900 border border-brand-yellow/30 rounded-xl p-6 text-center" data-id="element-57">
          <p className="text-slate-500 text-sm line-through mb-1" data-id="element-58">
            Valor total: +$39.000 ARS
          </p>
          <p className="text-2xl md:text-3xl font-black text-brand-yellow" data-id="element-59">
            🎁 HOY: GRATIS
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-60">
            (solo por tiempo limitado)
          </p>
        </div>
      </div>
    </section>;
}